import { render, staticRenderFns } from "./NumberRule.vue?vue&type=template&id=1d6c4993&scoped=true&"
import script from "./NumberRule.vue?vue&type=script&lang=ts&"
export * from "./NumberRule.vue?vue&type=script&lang=ts&"
import style0 from "./NumberRule.vue?vue&type=style&index=0&id=1d6c4993&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6c4993",
  null
  
)

export default component.exports